const about = {
  title: "COMMENT ÇA MARCHE ?",
  contentSection: {
    title: "Tout d’abord, iizenglish propose :",
    paragraphs: [
      [
        "Exercices interactifs et auto-corrigés (grammaire, vocabulaire, compréhension orale et expression, ainsi que des quiz sur la culture anglophone) sur les niveaux A1, A2, B1 et B2 du CECRL.",
        "Tests d’entraînement pour Ev{'@'}lang et certifications d’anglais.",
        "Diversité des activités et des supports proposés qui aide chaque élève à se sentir impliqué et donc actif dans son apprentissage.",
        "Des fiches de cours (à imprimer ou télécharger).",
        "1300 dessins (réalisés par Bod’Z, illustrateur).",
        "2000 enregistrements.",
      ],
      "Nos exercices s’appuient sur un contenu culturel riche, notamment à travers de nombreux textes et audios liés au monde anglophone et à l’actualité: vie quotidienne (nourriture, système scolaire, loisirs, sports, ma maison, mon quartier), spécificités culturelles (personnalités du monde anglophone, gap year), actualités (l’environnement, fast fashion, surconsommation, gaming, Gen Z, social media, JO).",
    ],
  },
  forWhoSection: {
    title: "Pour qui ?",
    paragraphs: [
      "Le site iizenglish peut être utilisé à titre individuel ou comme assistant pour un enseignant au sein de ses classes.",
    ],
  },
  HowDoesItWorkSection: {
    title: "Comment fonctionne le site iizenglish ?",
    forIndividuals: {
      title: "POUR L'ÉLÈVE OU LE PARTICULIER :",
      paragraphs: [
        "1. Vous vous inscrivez simplement en tant qu’élève en entrant vos nom et prénom, adresse email et un mot de passe que vous définissez.",
        "2. Vous aurez alors accès au sommaire de grammaire et vocabulaire et quelques exercices en accès libre sur lesquels vous pourrez vous entraîner.",
        "3. Pour profiter de l’intégralité des exercices et fiches associées, vous devrez souscrire un abonnement annuel.",
        "4. Après paiement en ligne, c’est parti pour un accès illimité au site iizenglish ainsi que les upgrades à venir.",
      ],
    },
    forTeachers: {
      title: "POUR L'ENSEIGNANT :",
      paragraphs: [
        "1. Vous vous inscrivez en tant qu’enseignant en entrant vos nom et prénom, adresse email et un mot de passe que vous définissez.",
        "2. Vous aurez alors accès au tableau de bord des enseignants.",
        "3. Vous créez alors votre classe en remplissant les noms, prénoms et adresses email de vos élèves. Ceux-ci recevront alors un email leur demandant de se connecter au site iizenglish et de régler leur cotisation annuelle.",
        "4. Dès que 10 élèves auront souscrit un abonnement, vous aurez alors accès à l’intégralité du sommaire ainsi que les fiches correspondantes pour une durée d’un an et pourrez créer des devoirs à faire en classe ou à la maison pour vos élèves.",
        "5. L’abonnement pour les enseignants est offert.",
      ],
    },
    forStudentsAttachedToTeacher: {
      title: "POUR LES ÉLÈVES RATTACHÉS À UN ENSEIGNANT :",
      paragraphs: [
        "1. Vous recevrez un email vous demandant de vous connecter au site iizenglish. Vous cliquez sur le lien reçu dans l’émail et vous créez votre mot de passe ou vous vous connectez avec vos identifiants si vous êtes déjà inscrit à titre personnel. (À noter que si vous avez déjà souscrit un abonnement, vous serez automatiquement connecté à votre enseignant sans autre démarche)",
        "2. Afin de recevoir les devoirs de votre enseignant, vous devrez régler votre abonnement annuel directement sur le site.",
        "3. Vous recevrez alors directement de votre enseignant les devoirs à réaliser. Vous aurez également accès à l’ensemble des exercices et fiches afin de vous entraîner quand vous le souhaitez.",
        "4. Lors de la réalisation d’un devoir, vous aurez droit à autant d’essais que vous le désirez, mais le site iizenglsih vous donnera à chaque fois des phrases différentes. Chaque devoir est unique. Seule la meilleure note de vos différents essais sera transmise à votre enseignant.",
      ],
    },
  },
  AndNowSection: {
    title: "Et maintenant ?",
    paragraphs: [
      "Je suis élève ou particulier :",
      "L’abonnement se fait directement sur le site à travers un paiement sécurisé.",
      "L’abonnement est de { price } pour une durée d’un an.",
      "Je suis enseignant :",
    ],
    links: [
      "Je crée mon compte et souscris un abonnement",
      "Je m'inscris et crée ma première classe",
    ],
  },
  bottomSection: {
    title: "COMMENT NOUS CONTACTER ?",
    paragraphs: [
      "Vous pouvez nous joindre en nous écrivant à l’adresse e-mail suivante : {'contact@iizenglish.com'}",
      "Si vous êtes un établissement, nous pouvons vous aider à inscrire vos enseignants et vos élèves de façon automatisée. N’hésitez pas à nous contacter.",
    ],
  },
};

export default about;
